module.exports = __webpack_public_path__ + "img/v8.1c25ad51.png";